import React, { useState, useEffect } from "react";
import debounce from "lodash/debounce";
import { Button, Checkbox } from "@public/ui-toolkit";

const TermsConditionComponent = ({ verifyTermsAndCondition, loading }) => {
  const [acceptTerms, setAcceptTerms] = useState({
    checkbox1: false,
    checkbox2: false,
  });
  const [isDisabled, setIsDisabled] = useState(true);

  let checkValue = Object.values(acceptTerms).every((x) => x !== false);

  const handleAcceptTerms = (event) => {
    const { name, checked } = event.target;

    if (acceptTerms[name] !== checked)
      setAcceptTerms((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
  };

  useEffect(() => {
    document
      .getElementById("tcHeight")
      .addEventListener("scroll", () => handleScroll());
    return () =>
      document
        .getElementById("tcHeight")
        ?.removeEventListener("scroll", handleScroll());
  }, []);

  const handleScroll = debounce((count) => {
    if (document.getElementById("tcHeight").scrollTop >= 3500)
      setIsDisabled(false);
  }, 500);

  return (
    <main>
      <div className="main-inner">
        <div className="container mt-5">
          <div className="rounded bg-white px-5 py-4 d-flex flex-column">
            <div className="wrapper_terms">
              <div className="mr-3">
                <h2 className="mb-4 w-50 text-center mx-auto d-block">
                  PLATFORM PARTICIPATION AGREEMENT
                </h2>
              </div>

              <div
                className="d-flex flex-column mt-lg-0 mt-4 fund-detail mr-3"
                style={{ height: "31rem", overflowY: "scroll" }}
                id="tcHeight"
              >
                <p>
                  By clicking ‘I Accept’ I agree to the below Terms and
                  Conditions and attest that I am employed by a qualified
                  institution buyer.
                </p>
                <p>
                  his Platform Participation Agreement (the “Agreement”) is
                  entered into as of today by and between Financial Capital
                  Network, Inc. (the “FCN”), having its main business address at
                  379 West Broadway, New York, NY 10012 and (the “Investor”)
                </p>
                <span>WITNESSETH:</span>
                <p>
                  WHEREAS, Investor or one of its affiliates manages and invests
                  funds professionally.
                </p>
                <p>
                  WHEREAS, FCN provides a platform product known as “Hedge Fund
                  Connect” (“Hedge Fund Connect”) which allows FCN to work as an
                  intermediary on behalf investors such as Inventor and hedge
                  funds to report certain information (the “Information”)
                  regarding the Hedge Funds to specified employees of Investor
                  (“Specified Recipients”);
                </p>
                <p>
                  WHEREAS, Investor desires to subscribe the Hedge Fund Connect
                  to utilized the Information in its investment processes.
                </p>
                <p>
                  NOW THEREFORE, for good and valuable consideration, the
                  receipt and sufficiency of which is hereby acknowledged, and
                  in consideration of the promises and of the covenants and
                  agreements herein contained, the parties hereto agree as
                  follows:
                </p>
                <h4>1. Hedge Fund Connect Subscription </h4>
                <p>
                  Investor hereby subscribes for participation in Hedge Fund
                  Connect as an investor. The subscription to Hedge Fund Connect
                  shall be governed by the terms of service attached hereto as
                  Schedule A. Investor covenants and agrees to the terms set
                  forth on Schedule A, which are incorporated herein.
                </p>
                <p>
                  In furtherance of the foregoing, each Specified Recipient
                  shall have a unique user access name and password, which shall
                  only be used during the Specified Recipient’s employment for
                  the Investor. [The Investor shall provide to FCN a list on a
                  monthly basis of any and all Specified Recipients]. The hereby
                  acknowledges that they are a qualified institutional buyer.
                </p>
                <h4>2. Compensation </h4>
                <p>
                  There shall be no subscription fee for the use of the Hedge
                  Fund Connect by Investor hereunder. If a investment is made
                  because of the platform the institutional investor
                  acknowledges it to FCN.
                </p>
                <h4>3. Term of Agreement</h4>
                <ul>
                  <li>
                    (a) Termination for Convenience. The term of this Agreement
                    shall mean the period from the date hereof and shall
                    continue indefinitely until terminated by either party
                    hereto by written notice thereof to the other parties hereto
                    sent not later than thirty (30) days prior to termination,
                    or immediately if termination is for cause (as set forth
                    below).  Notwithstanding the foregoing, FCN may terminate
                    this Agreement immediately in the event that its license
                    agreement with MSCI terminates or as set forth in Schedule A
                    hereto.{" "}
                  </li>
                  <li>
                    (b) Termination for Cause. Either party may terminate this
                    Agreement with immediate effect for Cause (as defined
                    below). As used herein, the term “Cause” shall mean: (i) any
                    act or omission by either party in the performance of its
                    duties under this Agreement amounting to gross negligence,
                    willful misconduct or fraud; or (ii) the entry by any court
                    or regulatory or self-regulatory body of an order or decree
                    as a result of which either party is effectively prohibited
                    or enjoined from performing its responsibilities under this
                    Agreement
                  </li>
                </ul>
                <h4>4. Representations and Warranties of Investor </h4>
                <p>Investor represents and warrants to FCN that:</p>
                <ul>
                  <li>
                    (a) Investor is duly organized and validly existing as a
                    limited liability company or limited partnership organized
                    under the state laws of its organization and has the
                    requisite power and authority to conduct its business.
                  </li>
                  <li>
                    (b) To the best of Investor’s knowledge, information and
                    belief, there are not any actions, suits or proceedings at
                    law or in equity or by or before any court or governmental
                    instrumentality or other agency now pending, or, threatened
                    against Investor, which if determined adversely, would
                    prevent Investor from entering into this Agreement.
                  </li>
                  <li>
                    (c) This Agreement has been validly executed and delivered
                    by Investor and is the legal, valid and binding agreement of
                    Investor.
                  </li>
                  <li>
                    (d) No consent, approval, authorization or order of any
                    court, governmental agency, authority or body or any party
                    to an agreement to which Investor is a party or by which
                    Investor is bound is required in connection with the
                    execution, delivery and performance of this Agreement by the
                    Investor, except for those that have been obtained.
                  </li>
                  <li>
                    (e) Investor understands and acknowledges that FCN or its
                    affiliates may provide services, including private placement
                    and investment banking services, to the hedge funds and
                    other parties utilizing Hedge Fund Connect, and may charge
                    and collect fees from such hedge funds based on investments
                    made by the Investor or its affiliates into such hedge
                    funds. Investor shall not attempt to circumvent or otherwise
                    structure any such investment into any such hedge fund in
                    way to avoid payment of such fees to FCN.
                  </li>
                  <li>
                    (f) Investor understands and acknowledges that FCN has not
                    and undertakes no obligations to verify the accuracy or
                    sufficiency of the Information, and therefore, it not
                    responsible in any way for the Information.
                  </li>
                </ul>
                <h4>3. Term of Agreement</h4>
                <ul>
                  <li>
                    (a) Termination for Convenience. The term of this Agreement
                    shall mean the period from the date hereof and shall
                    continue indefinitely until terminated by either party
                    hereto by written notice thereof to the other parties hereto
                    sent not later than thirty (30) days prior to termination,
                    or immediately if termination is for cause (as set forth
                    below). Notwithstanding the foregoing, FCN may terminate
                    this Agreement immediately in the event that its license
                    agreement with MSCI terminates or as set forth in Schedule A
                    hereto.
                  </li>
                  <li>
                    (b) Termination for Cause. Either party may terminate this
                    Agreement with immediate effect for Cause (as defined
                    below). As used herein, the term “Cause” shall mean: (i) any
                    act or omission by either party in the performance of its
                    duties under this Agreement amounting to gross negligence,
                    willful misconduct or fraud; or (ii) the entry by any court
                    or regulatory or self-regulatory body of an order or decree
                    as a result of which either party is effectively prohibited
                    or enjoined from performing its responsibilities under this
                    Agreement
                  </li>
                </ul>
                <h4>5. Representations and Warranties of FCN </h4>
                <p>FCN represents and warrants to Investor that:</p>
                <ul>
                  <li>
                    (a) The FCN is a corporation duly organized and validly
                    existing under the laws of the State of Delaware.
                  </li>
                  <li>
                    (b) To the best of FCN’s knowledge, information and belief,
                    there are not any actions, suits or proceedings at law or in
                    equity or by or before any court or governmental
                    instrumentality or other agency now pending, or, threatened
                    against FCN, which if determined adversely, would prevent
                    FCN from entering into this Agreement
                  </li>
                  <li>
                    (c) This Agreement has been duly authorized, validly
                    executed and delivered on behalf of the FCN and is the valid
                    and binding agreement of FCN enforceable in accordance with
                    its terms.
                  </li>
                  <li>
                    (d) No consent, approval, authorization or order of any
                    court, governmental agency, authority or body or any party
                    to an agreement to which Investor is a party or by which FCN
                    is bound is required in connection with the execution,
                    delivery and performance of this Agreement by FCN, except
                    for those that have been obtained.
                  </li>
                </ul>
                <h4>6. Confidentiality</h4>
                <p>
                  Without the written consent of any Party to this Agreement, no
                  other party or any Affiliate (as defined below) of said party
                  may disclose the confidential terms of this Agreement to any
                  person or entity outside of its company (including outside
                  service providers such as prime brokerage capital introduction
                  teams, lawyers, accountants, other hedge fund Investors, other
                  related outside marketing parties, with the exclusion of the
                  direct service providers, lawyers and auditors of the Investor
                  should there be specific information that they may need to
                  know), or to any person or entity within its company not
                  having a need to know for the purposes of using Hedge Fund
                  Connect as contemplated by this Agreement.
                </p>
                <p>
                  The Parties acknowledge that the unauthorized disclosure of
                  any Confidential Information to third parties, or unauthorized
                  circumvention with respect to any Confidential Information,
                  may result in significant damages to the Party providing
                  Confidential Information. Each Party agrees to keep
                  confidential all Confidential Information provided to it by
                  the other Party, and not to use any such information for its
                  own gain. For purposes of this Agreement, Confidential
                  Information shall include non-public information provided
                  through Hedge Fund Connect.
                </p>
                <p>
                  Each party will take all necessary actions to provide for the
                  safekeeping of any confidential information, in whole or in
                  part, to prevent distribution of the information to any third
                  party without prior written consent of the other party.
                  “Affiliate,” as used in this Agreement, means a person or
                  persons who control, or are controlled by any other person, or
                  are both under the common control of a third person.
                </p>
                <p>
                  The FCN and Investor each shall use its best efforts to
                  safeguard the secrecy and confidentiality of all confidential
                  and proprietary information of the other party and shall not
                  disclose any of the foregoing to any third party except the
                  following:
                </p>
                <ul>
                  <li>
                    1. Information which at the time of disclosure is part of
                    the public knowledge or literature and is readily accessible
                    to such third party, provided that any combination of
                    features shall not be deemed within exception merely because
                    individual features are part of the public knowledge or
                    literature and readily accessible to such third party, but
                    only if the combination itself and its principle of
                    operation are part of the public knowledge or literature and
                    are readily accessible to such third party.
                  </li>
                  <li>
                    2. Information required by law or any regulatory requirement
                    to be disclosed.
                  </li>
                  <li>
                    3. Information as permitted by the terms of this Agreement.
                  </li>
                </ul>
                <h4>7. Indemnification </h4>
                <p>
                  The Investor agrees to indemnify and hold harmless the FCN,
                  its information providers, and any other third party involved
                  in or related to the making or compiling of the Information or
                  providing Hedge Fund Connect, their affiliates and
                  subsidiaries and their respective directors, officers,
                  employees and agents (each such person, including Advisor, an
                  "Indemnified Party") from and against any losses, claims,
                  damages and liabilities, joint or several (collectively, the
                  "Damages"), to which such Indemnified Party may become subject
                  in connection with or otherwise relating to or arising from
                  (i) any transaction contemplated by this Agreement or (ii)
                  arising in any manner out of the Investor’s or any third
                  party's use of, or inability to use, the Hedge Fund Connect or
                  any breach by the Investor of any provision contained in this
                  Agreement and will reimburse each Indemnified Party for all
                  out-of-pocket fees and expenses (including the fees and
                  expenses of counsel) (collectively, "Expenses") as incurred in
                  connection with investigating, preparing, pursuing or
                  defending any threatened or pending claim, action, proceeding
                  or investigation (collectively, the "Proceedings") arising
                  therefrom, whether or not such Indemnified Party is a formal
                  party to such Proceeding; provided, that the Investor will not
                  be liable to any such Indemnified Party to the extent that any
                  Damages are found in a final non-appealable judgment by a
                  court of competent jurisdiction to have resulted from the
                  gross negligence or willful misconduct of the Indemnified
                  Party seeking indemnification hereunder. The Investor also
                  agrees that no Indemnified Party will have any liability
                  (whether direct or indirect, in contract, tort or otherwise)
                  to the Investor, or any person asserting claims on behalf of
                  the Investor arising out of or in connection with any
                  transactions contemplated by this Agreement except to the
                  extent that any Damages are found in a final non-appealable
                  judgment by a court of competent jurisdiction to have resulted
                  from the gross negligence or willful misconduct of the
                  Indemnified Party.
                </p>
                <p>
                  Promptly after receipt by an Indemnified Party of notice of
                  the commencement of an action or claim to which
                  indemnification under this Section 7 may apply, the
                  Indemnified Party shall notify the Investor in writing of
                  commencement of such action or claim if a claim or
                  indemnification in respect of such action or claim may be made
                  against the Investor under this Section 7; but the omission so
                  to notify the Investor shall not relieve it from any liability
                  which the indemnifying party it may have to the Indemnified
                  Party (except where such omission shall have materially
                  prejudiced the indemnifying party) or otherwise. In case of
                  any such action or claim shall be brought against an
                  Indemnified Party and the Indemnified Party shall notify the
                  Investor of the commencement of such action or claim, the
                  Investor shall be entitled to participate in such action or
                  claim and, to the extent that the Investor may desire, to
                  assume the defense of such action or claim with counsel
                  selected by the Investor and approved by the Indemnified
                  Party. After notice from the Investor to the Indemnified Party
                  of the Investor’s election so to assume the defense of such
                  action or claim, the Investor shall not be liable to the
                  Indemnified Party for any legal, accounting and other fees and
                  expenses subsequently incurred by the Indemnified Party in
                  connection with the defense of such action or claim other than
                  reasonable costs of investigation, except as set forth in the
                  following paragraph.
                </p>
                <p>
                  Notwithstanding any provision of this Section 7 to the
                  contrary, if any action or claim as to which indemnity is or
                  may be available, an Indemnified Party shall determine that
                  its interests are or may be adverse, in whole or in part, to
                  the interest of the Investor or that there may be legal
                  defenses available to the Indemnified Party which are or may
                  be different from, in addition to, or inconsistent with the
                  defenses available to the Investor, the Indemnified Party may
                  retain its own counsel in connection with such action or
                  claim, in which case the Investor shall be responsible for any
                  and all legal, accounting or any other expenses reasonably
                  incurred by or on behalf of Indemnified Party in connection
                  with investigating or defending such action or claim. In the
                  event such separate counsel is retained by the Indemnified
                  Party, the legal fees for which Investor shall be responsible
                  for such counsel shall be reasonable. In no event shall
                  Investor be liable for the fees and expenses of more than one
                  counsel for all Indemnified Parties in connection with
                  separate but similar or related actions or claims in the same
                  jurisdiction arising out of the same general allegations. The
                  Investor shall not be liable for a settlement of any such
                  action or claim effected without its written consent, but if
                  any such action or claim shall be settled with the written
                  consent of the Investor or if there shall be a final judgment
                  for the plaintiff in any such action or claim, the Manger
                  shall indemnify, hold harmless and defend an Indemnified Party
                  from and against any loss, liability or expense in accordance
                  with Section 7 by reason of such settlement or judgment.{" "}
                </p>
                <p>
                  Each of the parties to this Agreement understands that the
                  obligations of each party pursuant to this Section 7 are
                  separate and distinct.
                </p>
                <p>
                  The indemnities and obligations set forth in this Section 7
                  shall survive the termination of this Agreement and are in
                  addition to any other obligations or liabilities the parties
                  hereto may have.
                </p>
                <h4>8. Arbitration</h4>
                <p>
                  The parties hereto agree that any action or proceeding arising
                  directly, indirectly, or otherwise in connection with, out of,
                  related to, or from this agreement, any breach hereof, or any
                  transaction covered hereby, shall be resolved by arbitration,
                  within the State of New York. Accordingly, the parties consent
                  and submit to the jurisdiction of the federal and state courts
                  and any applicable arbitral body located within the State of
                  New York. The parties further agree that any such action or
                  proceeding brought by either party to enforce any right,
                  assert any claim, or obtain any relief whatsoever in
                  connection with this agreement shall be brought by such party
                  exclusively in the federal or state courts, or if appropriate
                  before any applicable arbitral body, located within the State
                  of New York.
                </p>
                <h4>9. Miscellaneous</h4>
                <ul>
                  <li>
                    (a) Complete Agreement. This Agreement constitutes the
                    entire agreement between the Parties with respect to the
                    matters referred to herein, and no other agreement, verbal
                    or otherwise, shall be binding as between the parties unless
                    it is in writing and signed by the party against whom
                    enforcement is sought.
                  </li>
                  <li>
                    (b) Assignment. This Agreement may not otherwise be assigned
                    by either party without the prior written consent of the
                    other party. This Agreement shall inure to the benefit of
                    the parties hereto and their respective successors and
                    assigns. Investor may assign its rights and obligations
                    hereunder to a third party in the event of a merger,
                    consolidation or sale of Investor or substantially all of
                    its assets.
                  </li>
                  <li>
                    (c) Independent Contractor. FCN and Investor shall be deemed
                    as independent contractors and unless otherwise expressly
                    provided herein or with the prior written authorization of
                    the other party, no party shall have authority to act for or
                    represent any other party, its affiliates, officers,
                    directors or employees in any way and shall not otherwise be
                    deemed to be an agent of any other party. Nothing contained
                    herein shall create or constitute among the Parties any
                    partnership, joint venture, association, syndicate,
                    unincorporated business, or other separate entity, nor shall
                    this Agreement be deemed to confer on any of them any
                    expense implied, or apparent authority to incur any
                    obligation or liability on behalf of the other.
                  </li>
                  <li>
                    (d) Amendment; Waiver. This Agreement may not be amended
                    except by the written consent of both the FCN and Investor.
                    No waiver of any provision of this Agreement may be implied
                    from any course of dealing between the parties or from any
                    failure by a party to assert its rights under this Agreement
                    on any occasion or series of occasions.
                  </li>
                  <li>
                    (d) Severability. If any provision of this Agre­ement, or
                    the application of any provision to any person or
                    ci­rcumstance, shall be held to be inconsistent with any
                    law, ruling, rule or regulation, the remainder of this
                    Agreement, or the application of the provision to persons or
                    circum­stances other than those as to which it is held
                    inconsistent, shall not be affected thereby.
                  </li>
                  <li>
                    (d) Severability. If any provision of this Agre­ement, or
                    the application of any provision to any person or
                    ci­rcumstance, shall be held to be inconsistent with any
                    law, ruling, rule or regulation, the remainder of this
                    Agreement, or the application of the provision to persons or
                    circum­stances other than those as to which it is held
                    inconsistent, shall not be affected thereby.
                  </li>
                  (f) Notices. All notices required or desired to be delivered
                  under this Agreement shall be in writing and shall be
                  effective when delivered personally on the day delivered, or,
                  when given by registered or certified mail, postage prepaid,
                  return receipt requested, on the day of receipt, addressed as
                  follows (or to such other address as the party entitled to
                  notice shall designate):
                  <ul className="w-50 d-flex flex-column align-items-center justify-content-center mx-auto">
                    <li>If to Investor:</li>
                    <li>[INVESTOR NAME]</li>
                    <li>[Address]</li>
                    <li className="mb-3">Attn: </li>

                    <li>If to Investor:</li>
                    <li>FCN</li>
                    <li>379 West Broadway</li>
                    <li>New York, NY 10012</li>
                  </ul>
                  <li>
                    (g) Governing Law. This Agreement shall be governed by and
                    construed in accordance with New York (e­xcluding the law
                    thereof which requires the application of, or reference to,
                    the law of any other jurisdiction).
                  </li>
                  <li>
                    (h) Counterparts. This Agreement may be executed in one or
                    more counterparts, all of which together shall constitute
                    one original Agreement.
                  </li>
                  <li>
                    (i) Headings. Headings to sections and subsections in this
                    Agreement are for the convenience of the parties and do not
                    form a part of or affect the meaning of this Agreement.
                  </li>
                  <li>
                    (j) Attorneys’ Fees. In any litigation between the parties
                    concerning this Agreement or its enforcement, the prevailing
                    party or parties in such litigation shall be entitled to
                    collect in such action from the non-prevailing party or
                    parties all costs of such litigation, including reasonable
                    attorneys’ fees at all levels of proceedings.
                  </li>
                  <li>
                    (k) Survival. The parties agree that Sections 4, 5, 6, 7 and
                    9 shall survive the termination of this Agreement
                    indefinitely. The respective indemnities, representations
                    and warranties set forth in this Agreement shall survive any
                    termination of this Agreement.
                  </li>
                  <li>
                    (l) Binding Effect.  This Agreement shall be binding upon
                    Investor and FCN and their successors and assigns, and shall
                    inure solely to the benefit of the Investor, FCN and their
                    respective successors and assigns, and no other person shall
                    acquire or have any right under or by virtue of this
                    Agreement, except as explicitly set forth herein including
                    Schedule A hereto.  This Agreement is not assignable by
                    either party without the prior written consent of the other
                    party, except as explicitly set forth herein.
                  </li>
                </ul>
                <p className="mt-3">
                  In witness whereof, this Agreement has been executed as of the
                  date recorded and your IP address.{" "}
                </p>
                <div className="w-50 mx-auto d-block text-center mt-5">
                  <h4>Schedule A</h4>
                  <h4>Hedge Fund Connect Subscription Terms</h4>
                  <h4>* * *</h4>
                  <h4>General Terms and Conditions</h4>toggle checkbox using
                  formik
                  <h4>* * *</h4>
                </div>
                <h4>1. Use of Product</h4>
                <ul>
                  <li>
                    (a) FCN hereby grants to the Investor a nonexclusive,
                    nontransferable license for the product known as Hedge Fund
                    Connect (the “Product”), on the terms set forth herein.
                  </li>
                  <li>
                    (b) Investor hereby agrees that the information provided via
                    the Product (“Information”) shall be used solely on an
                    internal use basis. For the avoidance of doubt, Investor
                    shall not use the Information or the Product for any other
                    purpose, and shall not distribute the Information or the
                    Product to any third party. Investor shall be responsible
                    for ensuring that its Specified Recipients do not further
                    distribute or disseminate the Information.
                  </li>
                  <li>
                    (c) Investor shall not use or permit anyone else to use the
                    Information or Product in connection with the creating,
                    managing, advising, writing, trading, marketing or promotion
                    of any securities or financial instruments or products,
                    including, but not limited to, funds, synthetic or
                    derivative securities (e.g., options, warrants, swaps, and
                    futures), whether listed on an exchange or traded over the
                    counter or on a private-placement basis or otherwise or to
                    create any indices (custom or otherwise).
                  </li>
                </ul>
                <h4>2. Disclosure Schedule </h4>
                <ul>
                  <li>
                    (a) To the extent available, Investor shall identify the
                    Specified Recipients via appropriate functionality in the
                    Product. If such functionality is unavailable, Investor
                    shall submit the names of Specified Recipients by written
                    notice (which may be by electronic means) in a timely manner
                    to FCN, either directly or through a designated third party.
                  </li>
                </ul>
                <h4>3. Ownership of Product. </h4>
                <p>
                  Investor shall treat the Product as proprietary to MSCI, Inc.
                  (“MSCI”) and FCN. Investor acknowledges that, as between MSCI
                  and Investor, MSCI anf FCN are the sole and exclusive owner of
                  the Product and any trade secrets, copyrights, trademarks and
                  other intellectual property rights in or to the Products.
                </p>
                <h4>4. Termination by MSCI. </h4>
                <p>
                  MSCI and FCN may, in its sole and absolute discretion and at
                  any time, terminate the Investor’s right to receive and/or use
                  the Product.
                </p>
                <h4>5. Use of the Product </h4>
                <p>
                  Investor shall not (i) copy any component of the Product, (ii)
                  alter, modify or adapt any component of the Product,
                  including, but not limited to, translating, decompiling,
                  disassembling, reverse engineering or creating derivative
                  works, or (iii) make any component of the Product available to
                  any other person or organization (including, without
                  limitation, the Investor’s present and future parents,
                  subsidiaries or affiliates) directly or indirectly, for any of
                  the foregoing or for any other use, including, without
                  limitation, by loan, rental, service bureau, external time
                  sharing or similar arrangement. The Product shall be the then
                  current version of the Hedge Fund Connect. The Product is
                  provided on an “as-is” basis by FCN.
                </p>
                <h4>6. Indemnity</h4>
                <p>
                  In addition to any indemnity obligation contained in the
                  Agreement, Investor assumes the entire risk of using the
                  Services and will defend, indemnify, save and hold harmless
                  FCN, MSCI and their respective affiliates and representatives
                  (the “MSCI Indemnitees”) from any and all from any and all
                  direct damages, costs or expenses, including reasonable
                  attorney’s fees resulting from Investor’s use of the
                  Information, the Product, or other data or services hereunder.
                </p>
                <h4>7. Limitation on Liability; Disclaimer. </h4>
                <ul>
                  <li>
                    (a) Limitation on Liability. INVESTOR ASSUMES THE ENTIRE
                    RISK OF ANY USE INVESTOR MAY MAKE OF THE PRODUCT. EXCEPT FOR
                    THE BREACH OF THE CONFIDENTIALITY OBLIGATIONS IN SECTION 6
                    OF THE AGREEMENT BY EITHER PARTY, WHICH SHALL BE RESTRICTED
                    TO LIABILITY FOR DIRECT DAMAGES BUT SHALL NOT BE SUBJECT TO
                    FINANCIAL LIMIT, IN NO EVENT SHALL EITHER FCN, ITS
                    INFORMATION PROVIDERS OR ANY THIRD PARTY INVOLVED OR RELATED
                    TO THE MAKING OR COMPILIING OF THE PRODUCT, BE LIABLE TO
                    INVESTOR, ANY FUND OR ANY OTHER PARTY FOR ANY DIRECT,
                    INDIRECT, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES
                    (INCLUDING BUT NOT LIMITED TO SUCH DAMAGES ARISING FROM
                    BREACH OF CONTRACT OR WARRANTY OR FROM NEGLIGENCE OR STRICT
                    LIABILITY), INCLUDING LOSS OF PROFITS, REVENUE, DATA OR USE,
                    OR FOR INTERRUPTED COMMUNICATIONS, INCURRED BY INVESTOR, ANY
                    FUND OR ANY OTHER THIRD PARTY IN CONNECTION WITH THIS
                    AGREEMENT, EVEN IF SUCH PARTY OR ANY OTHER PERSON HAS BEEN
                    ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                  </li>
                  <li>
                    b. Disclaimer. THE INFORMATION, THE PRODUCT, AND ANY AND ALL
                    OTHER INFORMATION PROVIDED OR PRODUCED PURSUANT TO THIS
                    AGREEMENT BY EITHER PARTY IS PROVIDED OR PRODUCED BY THE
                    RELEVANT PARTY “AS IS.”. FCN, ITS INFORMATION PROVIDERS, AND
                    ANY OTHER THIRD PARTY INVOLVED IN OR RELATED TO THE MAKING
                    OR COMPILING OF THE PRODUCT MAKE NO REPRESENTATION OR
                    WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED, WITH
                    RESPECT TO THE SERVICES (OR THE RESULTS TO BE OBTAINED BY
                    THE USE THEREOF). FCN, ITS INFORMATION PROVIDERS AND ANY
                    OTHER THIRD PARTY INVOLVED IN OR RELATED TO THE MAKING OR
                    COMPILING OF THE SERVICES EXPRESSLY DISCLAIM ANY AND ALL
                    IMPLIED WARRANTIES OF ORIGINALITY, ACCURACY, COMPLETENESS,
                    NON-INFRINGEMENT, MERCHANTABILITY AND FITNESS FOR ANY
                    PARTICULAR PURPOSE.
                  </li>
                </ul>
                <h4>8. Third Party Beneficiary.</h4>
                <p>
                  Investor acknowledges and understands that certain portions of
                  the Product includes and/or incorporates certain services and
                  products provided to FCN by MSCI or its affiliates.
                  Accordingly, Investor acknowledges and agrees that MSCI is an
                  intended third-party beneficiary of this Agreement, including
                  this indemnity provisions included in this Schedule A, solely
                  to the extent such provisions apply to the Product, and MSCI
                  may enforce such provisions against Investor as if MSCI were a
                  direct party hereto.
                </p>
              </div>
            </div>
            <div className="mt-5 d-flex justify-content-between">
              <div className="d-flex" onChange={handleAcceptTerms}>
                <Checkbox
                  label={"I Accept"}
                  className="mr-4"
                  type="checkbox"
                  name="checkbox1"
                  value="accept"
                  disabled={!!isDisabled}
                />
                <Checkbox
                  label={"I Attest that I am Qualified Institutional Buyer"}
                  type="checkbox"
                  name="checkbox2"
                  value="attest"
                  disabled={!!isDisabled}
                />
              </div>
              <div>
                <Button
                  loading={loading}
                  btnName="Submit"
                  btnType="primary"
                  onClick={verifyTermsAndCondition}
                  disabled={!checkValue}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default TermsConditionComponent;
